import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export const fmtDate = (d: string | Date | null | undefined) => (d ? dayjs(d).format('D MMM YYYY') : '—');
export const fmtDateTime = (d: string | Date | null | undefined) => (d ? dayjs(d).format('D MMM YYYY, HH:mm') : '—');
export const fromNow = (d: string | Date | null | undefined) => (d ? dayjs(d).fromNow() : '—');
export const isoDate = (d: string | Date | null | undefined) => (d ? dayjs(d).format('YYYY-MM-DD') : '');
export const isOverdue = (due: string | null | undefined, status?: string) =>
  !!due && dayjs(due).isBefore(dayjs().startOf('day')) && !['resolved', 'closed', 'rejected'].includes(status ?? '');

export function fmtBytes(n: number) {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}
